module.exports = __webpack_public_path__ + "static/media/carta_5.d7fef402.jpg";